import { Moon, Sun } from "lucide-react";

import { ColocaIconButton } from "@/shared/components/buttons/ColocaIconButton";
import type { Theme } from "@/shared/theme/ThemeContext";

interface ThemeSwitchProps {
  theme: Theme;
  toggleTheme: () => void;
  /** @deprecated kept for backwards compatibility — DS tokens adapt to the active theme automatically. */
  white?: boolean;
}

export const ThemeSwitch = ({ theme, toggleTheme }: ThemeSwitchProps) => (
  <ColocaIconButton
    variant="ghost"
    icon={theme === "light" ? Moon : Sun}
    onClick={toggleTheme}
    aria-label={theme === "light" ? "Switch to dark mode" : "Switch to light mode"}
  />
);
